/* eslint-disable react/prop-types */
import React from 'react';
import PropTypes from "prop-types";
import styles from './link.module.scss'

export default function Link({icon, path, linkText, description}) {
  return (
    <a
    className={styles.link}
    target="_blank"
    href={`${process.env.HERCULES_BACKEND_URL}${path}`}
    rel="noreferrer"
  >
    <span className={styles.title}>{icon && icon} {linkText}</span>
    <p className={styles.desc}>{description}</p>
  </a>
  )
}

Link.propTypes = {
  icon: PropTypes.node,
  path: PropTypes.string,
  linkText: PropTypes.string,
  description: PropTypes.string
};